import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-view-journal',
  templateUrl: './view-journal.component.html',
  styleUrls: ['./view-journal.component.css']
})
export class ViewJournalComponent implements OnInit {
  journalList: any;
  userId: any;

  constructor(public mainService: MainService, private activatedroute: ActivatedRoute) { }

  ngOnInit() {
    this.activatedroute.params.subscribe((res) => {
      this.userId = res.id;
    })
     this.getJournalList()
  }

// get faq by id
  getJournalList() {
    this.mainService.showSpinner();
    this.mainService.getApi(ApiUrls.view_journalQuestion + `?_id=${this.userId}`, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.journalList = res.result;
        this.mainService.hideSpinner();
        // this.mainService.successToast(res.responseMessage);
      } else {
        this.mainService.hideSpinner();
        this.mainService.errorToast(res.responseMessage)
      }
    })
  }

}
